(function () {
  'use strict';

  // Parse quiz answers from URL
  function getQuizAnswers() {
    const params = new URLSearchParams(window.location.search);
    return {
      budget: parseInt(params.get('q1')) || null,
      height: parseInt(params.get('q2')) || null,
      hours: parseInt(params.get('q3')) || null,
      adjust: parseInt(params.get('q4')) || null,
      lumbar: parseInt(params.get('q5')) || null
    };
  }

  // Score a product
  function scoreProduct(product, userAnswers) {
    const quizData = product.metafields?.custom?.quiz_data;
    if (!quizData) return 0;

    let totalScore = 0;

    // ---------------- Q1 Budget ----------------
    let q1 = 0;
    if (userAnswers.budget && quizData.budget) {
      const user = userAnswers.budget;
      const prod = parseInt(quizData.budget);
      const diff = user - prod;

      if (diff < 0) q1 = 0;
      else if (diff === 0) q1 = 3;
      else if (diff === 1) q1 = 2;
      else q1 = 1;

      totalScore += q1;
    }

    // ---------------- Q2 Height ----------------
    let q2 = 0;
    if (userAnswers.height && quizData.height) {
      const u = userAnswers.height;
      const arr = Array.isArray(quizData.height)
        ? quizData.height.map(h => parseInt(h))
        : [parseInt(quizData.height)];

      if (arr.includes(u)) q2 = 3;
      else if (arr.includes(u - 1) || arr.includes(u + 1)) q2 = 2;

      totalScore += q2;
    }

    // ---------------- Q3 Hours ----------------
    let q3 = 0;
    if (userAnswers.hours && quizData.hours) {
      let u = userAnswers.hours;
      if (u === 4) u = 3;

      const arr = Array.isArray(quizData.hours)
        ? quizData.hours.map(h => parseInt(h))
        : [parseInt(quizData.hours)];

      if (arr.includes(u)) q3 = 3;
      else if (arr.includes(u - 1) || arr.includes(u + 1)) q3 = 2;

      totalScore += q3;
    }

    // ---------------- Q4 Adjustability ----------------
    let q4 = 0;
    if (userAnswers.adjust && quizData.adjust) {
      let u = userAnswers.adjust;
      if (u === 4) u = 3;

      const prod = parseInt(quizData.adjust);

      if (prod >= u) q4 = 3;
      else if (prod === u - 1) q4 = 2;

      totalScore += q4;
    }

    // ---------------- Q5 Lumbar ----------------
    let q5 = 0;
    if (userAnswers.lumbar && quizData.lumbar) {
      q5 = parseInt(quizData.lumbar);
      totalScore += q5;
    }

    return totalScore;
  }

  // Best upgrade (product with higher budget than user)
  function getUpgradeProduct(scoredProducts, userBudget) {
    if (userBudget == null) return null;
    const candidates = scoredProducts.filter(p => {
      const pb = parseInt(p.budget);
      return !isNaN(pb) && pb > userBudget;
    });
    if (candidates.length === 0) return null;

    // prefer highest score, tie-break by smallest budget difference (smallest upgrade)
    candidates.sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      return parseInt(a.budget || 0) - parseInt(b.budget || 0);
    });

    return candidates[0];
  }

  function removeDuplicateProducts(products) {
    const seen = new Set();
    const unique = [];

    products.forEach(p => {
      const id = (p.element && p.element.getAttribute) ? p.element.getAttribute("data-product-id") : null;
      if (!id) return;
      if (!seen.has(id)) {
        seen.add(id);
        unique.push(p);
      }
    });

    return unique;
  }

  // Find a reasonable wrapper for a product element (tries many common patterns)
  function findWrapperForElement(el) {
    if (!el) return null;

    const candidates = [
      '.winning-team__item',
      'slideshow-slide',
      '.swiper-slide',
      '.product-card',
      '.grid__item',
      '.card',
      '.collection__item',
      '.product-grid-item',
      '.product-card-wrapper',
      'li',
      '.product-item',
      '.grid-item'
    ];

    for (let sel of candidates) {
      try {
        const w = el.closest(sel);
        if (w) return w;
      } catch (e) {
        // ignore invalid selector errors
      }
    }

    // fallback: climb up until parent's children count > 1 and parent is not body/html
    let node = el;
    let steps = 0;
    while (node && node.parentElement && node.parentElement.tagName.toLowerCase() !== 'body' && steps < 6) {
      if (node.parentElement.children.length > 1) {
        return node.parentElement;
      }
      node = node.parentElement;
      steps++;
    }

    return el;
  }

  function removeElementSafely(el) {
    if (!el) return;
    try {
      if (el.remove) el.remove();
      else if (el.parentNode) el.parentNode.removeChild(el);
    } catch (e) {
      // ignore
    }
  }

  function initQuizResults() {
    const userAnswers = getQuizAnswers();
    const productCards = Array.from(document.querySelectorAll('[data-product-id][data-quiz-data]'));
    if (productCards.length === 0 || !userAnswers.budget) return;

    const scoredProducts = [];

    // Score each product
    productCards.forEach(card => {
      const raw = card.getAttribute('data-quiz-data');
      if (!raw || raw === 'null') return;

      let quizData;
      try {
        quizData = JSON.parse(raw);
      } catch (e) {
        console.error("Invalid JSON:", raw);
        return;
      }

      const score = scoreProduct(
        { metafields: { custom: { quiz_data: quizData } } },
        userAnswers
      );

      scoredProducts.push({
        element: card,
        score,
        budget: parseInt(quizData.budget),
      });
    });

    if (scoredProducts.length === 0) return;

    // sort by highest score, tie-break by budget distance to user budget (closer wins),
    scoredProducts.sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;

      const aDiff = Math.abs((a.budget || 0) - userAnswers.budget);
      const bDiff = Math.abs((b.budget || 0) - userAnswers.budget);
      if (aDiff !== bDiff) return aDiff - bDiff;

      return (a.budget || 0) - (b.budget || 0);
    });

    // remove duplicate DOM elements by product id (keeps first occurrence)
    const uniqueProducts = removeDuplicateProducts(scoredProducts);

    // ensure sorted order preserved after dedupe (stable)
    uniqueProducts.sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      const aDiff = Math.abs((a.budget || 0) - userAnswers.budget);
      const bDiff = Math.abs((b.budget || 0) - userAnswers.budget);
      if (aDiff !== bDiff) return aDiff - bDiff;
      return (a.budget || 0) - (b.budget || 0);
    });

    // DEBUG: show ranking table in the console so you can verify
    try {
      console.groupCollapsed("Quiz product ranking");
      console.table(uniqueProducts.map(p => ({
        id: p.element.getAttribute('data-product-id'),
        score: p.score,
        budget: p.budget
      })));
      console.groupEnd();
    } catch (e) { /* ignore */ }

    // ---------------- TOP 3 FINAL ----------------
    const topResults = uniqueProducts.slice(0, 3);
    const topIds = topResults.map(p => (p.element && p.element.getAttribute) ? p.element.getAttribute("data-product-id") : null);

    // Upgrade suggestion (4th) — keep hidden in grid but available for compare table
    let upgradeOption = getUpgradeProduct(uniqueProducts, userAnswers.budget);

    // Force LiberNovo as the 4th card when budget is not the first tier
    // Find LiberNovo by product type/title text
    const liberNovoEl = productCards.find(card => {
      const t1 = (card.dataset.productType || '').toLowerCase();
      const t2 = (card.querySelector('.winning-team-title a')?.textContent || '').toLowerCase();
      const h  = (card.querySelector('.winning-team-link')?.getAttribute('href') || '').toLowerCase();
      return t1.includes('libernovo') || t2.includes('libernovo') || h.includes('libernovo');
    });
    // For both quiz pages showing libernovo product
    //const mustShowLiberNovo = (userAnswers.budget && userAnswers.budget !== 1);
    // For only simple quiz pages showing libernovo product(not for quiz teaser)
    const isTeaser = (window.location.pathname || '').includes('quiz-teaser-result');
    const mustShowLiberNovo = (userAnswers.budget && userAnswers.budget !== 1 && !isTeaser);
    if (mustShowLiberNovo && liberNovoEl) {
      // If LiberNovo is already in top 3, don't duplicate
      const libId = liberNovoEl.getAttribute('data-product-id');
      const isAlreadyTop = topResults.some(r => r.element.getAttribute('data-product-id') === libId);
      if (!isAlreadyTop) {
        upgradeOption = {
          element: liberNovoEl,
          score: 0,
          budget: parseInt(liberNovoEl.getAttribute('data-quiz-budget') || 0)
        };
      }
    }

    if (upgradeOption) {
      const upgradeId = upgradeOption.element.getAttribute("data-product-id");

      // ❗ If upgrade product is also in top 3, disable upgrade
      if (topIds.includes(upgradeId)) {
        upgradeOption = null;
      }
    }


    const upgradeId = (upgradeOption && upgradeOption.element && upgradeOption.element.getAttribute)
      ? upgradeOption.element.getAttribute("data-product-id")
      : null;

    // === STEP 1: Hide everything (clean state) ===
    productCards.forEach(card => {
      const wrapper = findWrapperForElement(card) || card;
      try { wrapper.style.display = 'none'; } catch (e) { /* ignore */ }
    });

    // === STEP 2: Remove all non-top, non-upgrade by product-id ===
    uniqueProducts.forEach(p => {
      const pid = (p.element && p.element.getAttribute) ? p.element.getAttribute("data-product-id") : null;
      if (!pid) return;

      const keepAsTop = topIds.includes(pid);
      const keepAsUpgrade = upgradeId && pid === upgradeId;

      if (!keepAsTop && !keepAsUpgrade) {
        // remove all nodes that have the data-product-id attribute equal to pid
        const allMatches = Array.from(document.querySelectorAll(`[data-product-id="${pid}"]`));
        if (allMatches.length > 0) {
          allMatches.forEach(m => {
            const wrapper = findWrapperForElement(m);
            removeElementSafely(wrapper);
          });
        } else {
          // fallback: try to remove the original element's wrapper
          const wrapper = findWrapperForElement(p.element);
          removeElementSafely(wrapper);
        }
      }
    });

    // === STEP 3: Show only top 3 (unhide their wrappers) ===

    // 🔥 FINAL ENFORCEMENT: force all top 3 wrappers visible
    topResults.forEach(result => {
      const pid = result.element.getAttribute("data-product-id");
      document.querySelectorAll(`[data-product-id="${pid}"]`).forEach(node => {

        // Find wrapper
        const wrapper = findWrapperForElement(node) || node;

        // Force visibility
        wrapper.style.removeProperty("display");
        wrapper.style.display = "block";

        // Fix cases where theme uses hidden class instead of display:none
        wrapper.classList.remove("hidden");
        wrapper.classList.remove("d-none");
        wrapper.classList.remove("is-hidden");

        // Remove lazy-theme fade container hiding quirks
        wrapper.removeAttribute("hidden");
      });
    });

    /*
    topResults.forEach(result => {
      const matchPercent = Math.round((result.score / 15) * 100);
      const el = document.querySelector(`[data-product-id="${result.element.getAttribute('data-product-id')}"]`) || result.element;
      const wrapper = findWrapperForElement(el) || el;
      try {
        wrapper.style.display = "block";
      } catch (e) {
        // if style setting fails, try direct element
        try { (result.element).style.display = 'block'; } catch (e2) {}
      }
      try { result.element.setAttribute("data-match-score", matchPercent); } catch (e) {}
    });
    */
    // Show upgrade as visible 4th card only when budget > 1 (and upgradeOption set)
    if (upgradeOption) {
      const upgradeId = upgradeOption.element.getAttribute("data-product-id");
      const upNode = document.querySelector(`[data-product-id="${upgradeId}"]`) || upgradeOption.element;
      const upWrapper = findWrapperForElement(upNode) || upNode;
      if (upWrapper) {
        if (mustShowLiberNovo) {
          // Make visible and move after the top 3
          upWrapper.style.removeProperty("display");
          upWrapper.style.display = "block";
          try {
            const container = upWrapper.parentElement;
            if (container) container.appendChild(upWrapper);
          } catch (e) { /* ignore */ }
        } else {
          upWrapper.style.display = "none";
        }
      }
    }

    // Expose selection globally for compare builders
    window.quizTopResults = {
      top: topResults.map(r => {
        const el = document.querySelector(`[data-product-id="${r.element.getAttribute('data-product-id')}"]`) || r.element;
        return findWrapperForElement(el) || el;
      }),
      upgrade: upgradeOption ? (findWrapperForElement(document.querySelector(`[data-product-id="${upgradeId}"]`) || upgradeOption.element) || upgradeOption.element) : null
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuizResults);
  } else {
    initQuizResults();
  }

})();


// Replace the buildQuizCompare function with this:
function buildQuizCompare(sectionEl, compareContainer){
    var selected = [];
    function isLiberNovoNode(node){
      if (!node) return false;
      var text = '';
      var link = node.querySelector('.winning-team-link');
      var titleEl = node.querySelector('.winning-team-title a');
      if (titleEl && titleEl.textContent) text += ' ' + titleEl.textContent.toLowerCase();
      if (link && link.getAttribute('href')) text += ' ' + link.getAttribute('href').toLowerCase();
      var card = node.querySelector('.winning-team-card') || node.closest('.winning-team-card') || node.querySelector('[data-product-id]');
      if (card) {
        var t1 = (card.dataset.productType || '').toLowerCase();
        var h  = (card.dataset.handle || '').toLowerCase();
        text += ' ' + t1 + ' ' + h;
      }
      return text.indexOf('libernovo') !== -1;
    }
    if (window.quizTopResults && window.quizTopResults.top) {
      selected = selected.concat(window.quizTopResults.top.slice(0,3));
      if (window.quizTopResults.upgrade && !isLiberNovoNode(window.quizTopResults.upgrade)) {
        selected.push(window.quizTopResults.upgrade);
      }
    } else {
      selected = Array.from(sectionEl.querySelectorAll('.winning-team__item')).slice(0,4);
    }
    selected = selected.filter(function(n){ return !isLiberNovoNode(n); }).slice(0,4);

    // Build selectedProducts for compare page section API
    window.selectedProducts = [];
    selected.forEach(function(item){
      var card = item.querySelector('.winning-team-card') 
                || item.closest('.winning-team-card') 
                || item.querySelector('[data-product-id]');
      var pidGuess = '';
      if (card && card.dataset && card.dataset.productId) { pidGuess = card.dataset.productId; }
      else if (item && item.getAttribute) { pidGuess = item.getAttribute('data-product-id') || ''; }
      // If the found element is not the actual product card, resolve canonical element by class
      if (card && !card.classList.contains('winning-team-card')) {
        var pidLocal = card.getAttribute && card.getAttribute('data-product-id');
        if (!pidLocal) {
          var inner = item.querySelector('.winning-team-card[data-product-id]');
          if (inner) { card = inner; pidLocal = inner.getAttribute('data-product-id'); }
        }
        if (pidLocal) {
          var canon = document.querySelector('.winning-team-card[data-product-id="'+pidLocal+'"]');
          if (canon) card = canon;
        }
      }
      // Also if card lacks key datasets, try canonical lookup anyway
      if (card && !card.dataset) {
        var canon2 = document.querySelector('.winning-team-card[data-product-id="'+pidGuess+'"]');
        if (canon2) card = canon2;
      }
      if (!card && pidGuess) {
        var canonical = document.querySelector('.winning-team-card[data-product-id="'+pidGuess+'"]');
        if (!canonical) canonical = document.querySelector('[data-product-id="'+pidGuess+'"].winning-team-card');
        if (!canonical) canonical = document.querySelector('[data-product-id="'+pidGuess+'"][data-quiz-data]');
        if (canonical) card = canonical;
      }
      // Fallback: use compare thumbnails as canonical data source if available
      var metaEl = null;
      if (pidGuess) {
        metaEl = document.querySelector('.thumb-item[data-product-id="'+pidGuess+'"]');
        if (!metaEl) {
          // try any element exposing specs for this product id (e.g., color swatch buttons)
          var swatchEl = document.querySelector('button.color-variant-swatch[data-product-id="'+pidGuess+'"]');
          if (swatchEl) metaEl = swatchEl.closest('.thumb-item');
        }
      }
      if (!card && !metaEl) return;
      var titleEl = item.querySelector('.winning-team-title a') || (card ? card.querySelector('.winning-team-title a') : null);
      var title = titleEl?.textContent?.trim() || card?.dataset.productType || '';
      if (!title) {
        var tAlt = (card?.dataset?.productType || '').trim();
        if (tAlt) title = tAlt;
        else if (metaEl && metaEl.dataset && metaEl.dataset.title) {
          title = metaEl.dataset.title;
        }
      }
      var productType = title;
      var priceText = item.querySelector('.winning-team-price')?.textContent?.trim() || card?.dataset.price || '';
      if (!priceText && card && card.getAttribute('data-price')) priceText = card.getAttribute('data-price');
      if (!priceText && metaEl && metaEl.dataset && metaEl.dataset.price) priceText = metaEl.dataset.price;
      
      // Get currently active/selected color
      var colorEl = item.querySelector('.winning-team-swatch.is-active') || item.querySelector('.swatch.is-active') || (card ? card.querySelector('.swatch.is-active') : null);
      var selectedColor = colorEl?.getAttribute('aria-label') || item.querySelector('.winning-team-color')?.textContent?.trim() || card?.dataset.currentColor || '';
      if (!selectedColor && card) {
        var colorText = card.querySelector('.winning-team-color')?.textContent?.trim();
        if (colorText) selectedColor = colorText;
        else if (card.dataset && card.dataset.currentColor) selectedColor = card.dataset.currentColor;
      }
      if (!selectedColor && metaEl && metaEl.dataset && metaEl.dataset.currentColor) {
        selectedColor = metaEl.dataset.currentColor;
      }
      
      // Get active slide image/video for selected color
      var activeSlide = item.querySelector('.winning-team-slide.active') || item.querySelector('.winning-team-slide') || (card ? card.querySelector('.winning-team-slide.active') || card.querySelector('.winning-team-slide') : null);
      var activeSlideImg = activeSlide?.querySelector('img') || item.querySelector('.winning-team-image') || item.querySelector('img') || (card ? card.querySelector('img') : null);
      var activeSlideVideo = activeSlide?.querySelector('video') || (card ? card.querySelector('video') : null);
      
      var src = activeSlideImg ? (activeSlideImg.getAttribute('src') || activeSlideImg.getAttribute('data-src') || '') : '';
      var activeVideoSources = '';
      if (!src && metaEl && metaEl.dataset && metaEl.dataset.image) src = metaEl.dataset.image;
      
      if (activeSlideVideo) {
        var sources = activeSlideVideo.querySelectorAll('source');
        var videoSourcesArr = [];
        sources.forEach(function(source) {
          var url = source.getAttribute('src');
          var type = source.getAttribute('type');
          if (url && type) {
            videoSourcesArr.push(url + '|' + type);
          }
        });
        activeVideoSources = videoSourcesArr.join(';');
      }
      if (!activeVideoSources && metaEl && metaEl.dataset && metaEl.dataset.videoSources) {
        activeVideoSources = metaEl.dataset.videoSources;
      }
      
      var linkEl = item.querySelector('.winning-team-link') || (card ? card.querySelector('.winning-team-link') : null);
      var handle = linkEl?.getAttribute('href') || card?.dataset?.handle || metaEl?.dataset?.handle || '';
      if (handle.startsWith('/products/')) handle = handle.replace('/products/', '');
      
      // Collect ALL variants (all color options with their media)
      var variants = [];
      var allSwatches = item.querySelectorAll('.winning-team-swatch, .swatch');
      if (allSwatches.length === 0 && card) allSwatches = card.querySelectorAll('.winning-team-swatch, .swatch');
      if (allSwatches.length === 0 && metaEl) allSwatches = metaEl.querySelectorAll('button.color-variant-swatch.swatch');
      var allSlides = item.querySelectorAll('.winning-team-slide');
      if (allSlides.length === 0 && card) allSlides = card.querySelectorAll('.winning-team-slide');
      if (allSlides.length === 0 && metaEl) allSlides = metaEl.querySelectorAll('.winning-team-slide');
      
      allSwatches.forEach(function(swatch, index) {
        var variantColor = swatch.getAttribute('aria-label') || swatch.getAttribute('data-color') || '';
        if (!variantColor) return;
        
        // Find corresponding slide for this color variant
        var slide = allSlides[index];
        if (!slide && swatch.dataset && (swatch.dataset.image || swatch.dataset.videoSources)) {
          variants.push({
            color: variantColor,
            image: swatch.dataset.image || '',
            videoSources: swatch.dataset.videoSources || ''
          });
          return;
        }
        if (!slide) return;
        
        var variantImg = slide.querySelector('img');
        var variantVideo = slide.querySelector('video');
        var variantImgSrc = variantImg ? (variantImg.getAttribute('src') || variantImg.getAttribute('data-src') || '') : '';
        var variantVideoSources = '';
        
        if (variantVideo) {
          var vSources = variantVideo.querySelectorAll('source');
          var vSourcesArr = [];
          vSources.forEach(function(source) {
            var url = source.getAttribute('src');
            var type = source.getAttribute('type');
            if (url && type) {
              vSourcesArr.push(url + '|' + type);
            }
          });
          variantVideoSources = vSourcesArr.join(';');
        }
        
        variants.push({
          color: variantColor,
          image: variantImgSrc,
          videoSources: variantVideoSources
        });
      });

      window.selectedProducts.push({
        id: card?.dataset.productId || '',
        title: title || 'ללא',
        productType: productType || 'ללא',
        image: src || '',
        selectedColor: selectedColor || '',
        videoSources: activeVideoSources || card?.dataset.videoSources || '',
        variants: variants, // All color variants with their media
        tilting_support: card?.dataset.tiltingSupport || metaEl?.dataset?.tiltingSupport || '',
        certificate: card?.dataset.certificate || metaEl?.dataset?.certificate || '',
        mesh_or_cushions: card?.dataset.meshOrCushions || metaEl?.dataset?.meshOrCushions || '',
        lumbar_support: card?.dataset.lumbar || metaEl?.dataset?.lumbar || '',
        adjustability: card?.dataset.adjustability || metaEl?.dataset?.adjustability || '',
        usage: card?.dataset.usage || metaEl?.dataset?.usage || '',
        fit_to_height: card?.dataset.fitToHeight || metaEl?.dataset?.fitToHeight || '',
        weight_of_the_chair: card?.dataset.weight || card?.dataset.weightOfTheChair || metaEl?.dataset?.weight || '',
        awards: card?.dataset.awards || metaEl?.dataset?.awards || '',
        foldable_chair: card?.dataset.foldable || metaEl?.dataset?.foldable || '',
        castors_wheels: card?.dataset.castors || metaEl?.dataset?.castors || '',
        sliding_sit: card?.dataset.slidingSit || metaEl?.dataset?.slidingSit || '',
        headrest: card?.dataset.headrest || metaEl?.dataset?.headrest || '',
        handrest: card?.dataset.handrest || metaEl?.dataset?.handrest || '',
        base: card?.dataset.base || metaEl?.dataset?.base || '',
        features: card?.dataset.features || metaEl?.dataset?.features || '',
        newton_executive: card?.dataset.newtonExecutive || metaEl?.dataset?.newtonExecutive || '',
        newton_quickfold: card?.dataset.newtonQuickfold || metaEl?.dataset?.newtonQuickfold || '',
        colors: card?.dataset.colors || metaEl?.dataset?.colors || '',
        price: card?.dataset.price || priceText || metaEl?.dataset?.price || '',
        handle: handle || metaEl?.dataset?.handle || ''
      });
    });

    console.log('🟢 Quiz Compare - selectedProducts:', JSON.stringify(window.selectedProducts));

    // Rest of the function remains same...

    // ✅ FIX: Wait for DOM to be ready before calling compare function
    if (typeof window.setCompareSelectedProducts === 'function') {
      // Add small delay to ensure DOM is fully rendered
      setTimeout(function() {
        window.setCompareSelectedProducts(window.selectedProducts);
      }, 100);
    } else {
      var attempts = 0;
      var timer = setInterval(function(){
        attempts++;
        if (typeof window.setCompareSelectedProducts === 'function') {
          clearInterval(timer);
          // Add small delay here too
          setTimeout(function() {
            window.setCompareSelectedProducts(window.selectedProducts);
          }, 100);
        } else if (attempts > 40) {
          clearInterval(timer);
          // Fallback: manually click compare button
          var compareBtn = document.getElementById('compare-btn');
          if (compareBtn) { 
            setTimeout(function() {
              compareBtn.click(); 
            }, 100);
          }
        }
      }, 100);
    }
}
